import { useTranslation } from 'react-i18next'
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { LifecycleStagesTab } from '@/pages/settings/lifecycle-stages-tab'
import { useStageManagerStore } from '@/stores/stage-manager-store'

/** Gắn MỘT lần ở khung ứng dụng (app-layout). Mở bằng `openStageManager()` / nút ở manage-links. */
export function StageManagerDialog() {
  const { t } = useTranslation('sharedMisc')
  const open = useStageManagerStore((s) => s.open)
  const setOpen = useStageManagerStore((s) => s.setOpen)
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-3xl overflow-x-hidden">
        <DialogHeader>
          <DialogTitle>{t('stageManagerDialog.title')}</DialogTitle>
          <DialogDescription className="sr-only">{t('stageManagerDialog.description')}</DialogDescription>
        </DialogHeader>
        {/* Chỉ mount khi mở để không gọi API lúc chưa cần; đóng hộp = bỏ thay đổi chưa lưu. */}
        {open && <LifecycleStagesTab />}
      </DialogContent>
    </Dialog>
  )
}
